import React, {useMemo} from "react";
import Card from "../../../WidgetCard";
import {
    RateScore,
    ReviewCardContainer,
    ReviewContent,
    ReviewProfile,
    ReviewProfileSection,
    ReviewTag,
    ReviewUserDetails,
    ReviewUserImage,
    ReviewUserName,
} from "./Styled";
import PropTypes from "prop-types";
import ReadMore from "../../../HTMLEntities/ReadMore";
import {getImageUrlBySize, prependDomainToImageUrl} from "../../../../utils/image";
import config from "../../../../config/config";
import {validateField} from "../../../../utils/validation";
import Image from "../../../HTMLEntities/Image";

const ReviewCard = ({review, makeApplyCardStyle = false}) => {
    // const {makeApplyCardStyle = false} = props;
    // const {review} = props;
    const admittedOrAppliedJSX = useMemo(() => {
        if (validateField(review, "object", "admittedTo")) {
            return (
                <p>
                    {" "}
                    <strong> Admitted: </strong>
                    {review.admittedTo}
                </p>
            );
        } else if (validateField(review, "object", "appliedTo")) {
            return (
                <p>
                    {" "}
                    <strong> Applied: </strong>
                    {review.appliedTo}
                </p>
            );
        }
        return null;
    }, [review]);
    const renderUserEducation = (review) => {
        if (validateField(review, "object", "education")) {
            let reviewEduLength = review.education.length;
            return review.education.map((eduVal, index) => {
                return (
                    <React.Fragment key={`eduC${index}`}>
                        <strong>{eduVal.key}: </strong> {eduVal.value}
                        {reviewEduLength !== index + 1 && `, `}
                    </React.Fragment>
                );
            });
        } else {
            return null;
        }
    };

    const handleReviewUserImageClick = (userProfileUrl) => {
        if (validateField(userProfileUrl)) {
            window.location.href = userProfileUrl;
        }
    };
    const userProfileUrl = validateField(review, "object", "url")
        ? `${config.SHIKSHA_STUDYABROAD_HOME}${review.url}`
        : null;
    const userProfileImg = validateField(review, "object", "profileImage")
        ? `${getImageUrlBySize(prependDomainToImageUrl(review.profileImage), "medium")}`
        : "";
    return (
        <Card
            cardStyle={{mobile: {padding: "0"}, laptop: {padding: "0"}}}
            widgetCardStyle={{
                mobile: {boxShadow: "none"},
                laptop: {boxShadow: "none"},
            }}
            makeApplyCardStyle={makeApplyCardStyle}
        >
            <ReviewCardContainer makeApplyCardStyle={makeApplyCardStyle}>
                <ReviewProfile makeApplyCardStyle={makeApplyCardStyle}>
                    <ReviewProfileSection makeApplyCardStyle={makeApplyCardStyle}>
                        <ReviewUserImage
                            makeApplyCardStyle={makeApplyCardStyle}
                            userProfileUrl={userProfileUrl}
                            onClick={() => handleReviewUserImageClick(userProfileUrl)}
                            data-testid="reviewUserImage"
                        >
                            <div>
                                <Image
                                    src={userProfileImg}
                                    alt={userProfileImg}
                                    isLazy
                                    intervalCheck
                                />
                            </div>
                        </ReviewUserImage>
                        <ReviewUserDetails makeApplyCardStyle={makeApplyCardStyle}>
                            {validateField(review, "object", "userName") && (
                                <ReviewUserName
                                    userProfileUrl={userProfileUrl}
                                    onClick={() => handleReviewUserImageClick(userProfileUrl)}
                                    data-testid="userNameWithCity"
                                >
                                    <strong>{review.userName}</strong>{" "}
                                    {validateField(review.city) && `from ${review.city}`}
                                </ReviewUserName>
                            )}
                            <p>{renderUserEducation(review)}</p>
                            {admittedOrAppliedJSX}
                        </ReviewUserDetails>
                    </ReviewProfileSection>
                    {validateField(review, "object", "reviewDate") && (
                        <ReviewProfileSection>
                            <span className="reviewTag">Reviewed {review.reviewDate}</span>
                        </ReviewProfileSection>
                    )}
                </ReviewProfile>
                <ReviewContent makeApplyCardStyle={makeApplyCardStyle} data-testid="reviewContent">
                    <p>
                        {validateField(review, "object", "rating") && (
                            <>
                                <strong>Rated</strong> <RateScore>{review.rating}</RateScore>
                            </>
                        )}
                        {validateField(review, "object", "reviewText") && (
                            <ReadMore
                                charLimit={makeApplyCardStyle ? 180 : 1500}
                                readMoreText={"Read More"}
                            >
                                {review.reviewText}
                            </ReadMore>
                        )}
                    </p>
                    {validateField(review, "object", "reviewDate") && (
                        <ReviewTag data-testid="reviewDate">Reviewed {review.reviewDate}</ReviewTag>
                    )}
                </ReviewContent>
            </ReviewCardContainer>
        </Card>
    );
};
ReviewCard.propTypes = {
    review: PropTypes.object,
    makeApplyCardStyle: PropTypes.bool,
};
export default ReviewCard;
